import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Anchor from 'sd-ui/dist/commonjs/components/Anchor/Anchor';
import Icon from '../icon';
import PanelContext from '../sidebar/panel/panelContext';
import PanelHeader from '../sidebar/panelHeader/panelHeader';
import PanelPaginationControls from '../sidebar/panelHeader/panelPaginationControls';
import RecentPublicationsListContainer from '../articleList/containers/recentPublicationsListContainer';

export default class Author extends Component {
  constructor(props) {
    super(props);
    this.goToNext = this.goToNext.bind(this);
    this.goToPrev = this.goToPrev.bind(this);
  }

  componentDidMount() {
    const { fetchAuthor, index, author: { isLoading, data } } = this.props;
    if (!data && !isLoading) fetchAuthor(index);
  }

  componentDidUpdate(prevProps) {
    const { fetchAuthor, index, author: { isLoading, data } } = this.props;
    const { author: { isLoading: wasLoading } } = prevProps;
    if (!wasLoading && !isLoading && !data) fetchAuthor(index);

    this.refPanel.scrollTop = 0;
  }

  goToNext() {
    const {
      context: { closeNextPanel },
      props: { goToNext },
    } = this;

    closeNextPanel();
    goToNext();
  }

  goToPrev() {
    const {
      context: { closeNextPanel },
      props: { goToPrev },
    } = this;

    closeNextPanel();
    goToPrev();
  }

  render() {
    let content = <span>There is no data available about this author.</span>;

    const {
      authorName: {
        initial, givenName, surName, surname,
      },
      authorCount,
      hasNext,
      hasPrev,
      author: { isLoading, data },
      index,
    } = this.props;

    const fullName = [(givenName || initial), (surName || surname)].filter(Boolean).join(' ');

    if (isLoading) {
      content = <div className="move-center u-margin-l-top"><Icon.Spinner /></div>;
    }

    if (data) {
      const contentChildren = [];
      if (data.scopusDocuments && data.scopusDocuments.length) {
        contentChildren.push(<RecentPublicationsListContainer key={0} />);
      } else {
        contentChildren.push(<span key={0}>No other articles are available</span>);
      }

      if (data.scopusAuthorId) {
        contentChildren.push(
          <div className="u-padding-s-bottom text-s" key={1}>
            <Anchor
              href={`https://www.scopus.com/authid/detail.uri?authorId=${data.scopusAuthorId}`}
              target="_blank"
              id={`more-articles-scopuseid-${data.scopusAuthorId}`}
              rel="noopener noreferrer"
            >
              View more articles by this author
            </Anchor>
          </div>,
        );
      }
      content = <>{contentChildren}</>;
    }
    return (
      <div className="author-panel sidebar-scroll-panel sidebar-panel-default-appearance">
        <PanelHeader title={`Authors (${index + 1}/${authorCount})`}>
          <PanelPaginationControls
            hasNext={hasNext}
            hasPrev={hasPrev}
            goToNext={this.goToNext}
            goToPrev={this.goToPrev}
          />
        </PanelHeader>
        <div
          className="sidebar-scroll-panel-body"
          id="author-panel"
          ref={(refPanel) => { this.refPanel = refPanel; }}
        >
          <div className="title u-clr-grey7 text-l u-margin-s-bottom">{fullName}</div>
          <h4 className="u-margin-s-bottom">Recent publications:</h4>
          {content}
        </div>
      </div>
    );
  }
}

Author.contextType = PanelContext;

Author.propTypes = {
  authorName: PropTypes.shape({
    givenName: PropTypes.string,
    surname: PropTypes.string,
    surName: PropTypes.string,
    initial: PropTypes.string,
  }).isRequired,
  authorCount: PropTypes.number.isRequired,
  hasNext: PropTypes.bool.isRequired,
  hasPrev: PropTypes.bool.isRequired,
  author: PropTypes.shape({
    isLoading: PropTypes.bool,
    data: PropTypes.shape({
      scopusAuthorId: PropTypes.string,
      scopusDocuments: PropTypes.arrayOf(PropTypes.shape({
        eid: PropTypes.string,
        itemTitle: PropTypes.string,
        pii: PropTypes.string,
        publicationDate: PropTypes.string,
        sourceTitle: PropTypes.string,
      })),
    }),
  }),
  index: PropTypes.number.isRequired,
  fetchAuthor: PropTypes.func.isRequired,
  goToNext: PropTypes.func.isRequired,
  goToPrev: PropTypes.func.isRequired,
};

Author.defaultProps = {
  author: { isLoading: false },
};
